<div class="center">
    <br>
    <h2>Reset Your Password</h2>
    <!-- Userid: {{userid}}
    Resettoken: {{resettoken}} -->

    Dear {{firstname.firstname}}:<br>
    <div style="place-items: left">The password must</div>
    <br>
    <ul>
        <li>be at least 8 characters long</li>
        <li>has at lest one upper and one lower case letter</li>
        <li>has at least one number</li>
        <li>has at least one special character</li>
    </ul>
    <br>
    <div style="max-width:300px">
        <label>Enter password</label><br>
        <input type="password"  class="form-control" [(ngModel)]="password" style="margin-bottom:20px"/>
        <label>Verify password</label><br>
        <input  type="password" class="form-control" [(ngModel)]="password2" style="margin-bottom:20px"/>
        <button class="btn btn-primary" (click)="reset()">Reset</button><br><br>
        {{message}}
        <br>
        <button class="btn btn-info" (click)="this.router.navigate(['login'])">Back to Login</button>
        
    </div>

</div>